import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaTint, 
  FaLeaf, 
  FaIndustry, 
  FaFlask, 
  FaScroll, 
  FaCheckCircle, 
  FaMoneyBillWave, 
  FaTruck, 
  FaHandshake, 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaWhatsapp,
  FaAward
} from 'react-icons/fa';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg">
          <img src="../Home Page images/mountain-bg.jpg" alt="Pure Mountain Source" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text animate-fadeInUp">
              <span className="hero-badge"><FaAward /> BIS & FSSAI Certified</span>
              <h1>Pure Water. <span className="text-gradient">Fresh Taste.</span></h1>
              <p>
                Experience the purity of Himalayan-grade packaged drinking water and 
                refreshing litchi juice. Manufactured with state-of-the-art technology 
                in Bareilly, UP.
              </p>
              <div className="hero-buttons">
                <Link to="/water-bottles" className="btn btn-primary">
                  Explore Products
                </Link>
                <Link to="/distributor" className="btn btn-secondary">
                  Become Distributor
                </Link>
              </div>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Happy Distributors</span>
                </div>
                <div className="stat">
                  <span className="stat-number">1M+</span>
                  <span className="stat-label">Bottles Delivered</span>
                </div>
              </div>
            </div>
            <div className="hero-image animate-fadeIn">
              <img src="/Home Page images/water-bottle-hero.jpg" alt="Shikhar Dhara Water Bottle" />
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products-section section">
        <div className="container">
          <div className="section-header">
            <h2>Our Premium Products</h2>
            <p>Discover our range of pure drinking water and refreshing fruit beverages</p>
          </div>
          
          <div className="products-grid">
            {/* Water Products */}
            <div className="product-card water-card">
              <div className="product-image">
                <img src="/Home Page images/WaterBottol.png" alt="Shikhar Dhara Water Bottle" />
              </div>
              <div className="product-content">
                <span className="product-badge"><FaTint /> Packaged Water</span>
                <h3>Pure Drinking Water</h3>
                <p>Crystal clear, BIS certified water in multiple sizes - 250ml, 500ml, 1L, and 20L jars.</p>
                <ul className="product-features">
                  <li><FaCheckCircle /> 7-Stage Purification</li>
                  <li><FaCheckCircle /> BIS Certified (IS 14543)</li>
                  <li><FaCheckCircle /> Mineral Enhanced</li>
                  <li><FaCheckCircle /> UV + RO Treated</li>
                </ul>
                <Link to="/products" className="btn btn-primary">
                  View Water Products
                </Link>
              </div>
            </div>

            {/* Juice Products */}
            <div className="product-card juice-card">
              <div className="product-image">
                <img src="/Home Page images/litchi-juicemain.jpg" alt="Litchi Juice Range" />
              </div>
              <div className="product-content">
                <span className="product-badge juice-badge"><FaLeaf /> Fruit Juice</span>
                <h3>Litchi Fruit Juice</h3>
                <p>Fresh, ready-to-serve litchi beverages made from premium quality litchi fruits.</p>
                <ul className="product-features">
                  <li><FaCheckCircle /> 100% Natural Flavor</li>
                  <li><FaCheckCircle /> FSSAI Approved</li>
                  <li><FaCheckCircle /> No Artificial Colors</li>
                  <li><FaCheckCircle /> Ready to Serve</li>
                </ul>
                <Link to="/products" className="btn btn-green">
                  View Juice Products
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview section bg-light">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-image">
              <img src="/Home Page images/factory-exterior.jpg" alt="Shikhar Dhara Manufacturing Facility" />
            </div>
            <div className="about-preview-content">
              <span className="section-label">About Shikhar Dhara</span>
              <h2>Committed to Purity & Quality Since Day One</h2>
              <p>
                Shikhar Dhara is a leading manufacturer of premium packaged drinking water 
                and litchi fruit juice based in Bareilly, Uttar Pradesh. Our state-of-the-art 
                facility ensures every drop meets the highest quality standards.
              </p>
              <div className="about-features">
                <div className="about-feature">
                  <span className="feature-icon"><FaIndustry /></span>
                  <div>
                    <h4>Modern Facility</h4>
                    <p>Fully automated production with international standards</p>
                  </div>
                </div>
                <div className="about-feature">
                  <span className="feature-icon"><FaFlask /></span>
                  <div>
                    <h4>Quality Lab</h4>
                    <p>In-house testing at every production stage</p>
                  </div>
                </div>
                <div className="about-feature">
                  <span className="feature-icon"><FaScroll /></span>
                  <div>
                    <h4>Certified</h4>
                    <p>FSSAI, BIS, and ISO certified products</p>
                  </div>
                </div>
              </div>
              <Link to="/about" className="btn btn-primary">
                Learn More About Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturing Process */}
      <section className="process-section section">
        <div className="container">
          <div className="section-header">
            <h2>Our Manufacturing Process</h2>
            <p>State-of-the-art technology ensuring pure and safe products</p>
          </div>
          
          <div className="process-image">
            <img src="/Home Page images/manufacturing-process.jpg" alt="Manufacturing Process" />
          </div>
          
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <h4>Source Water</h4>
              <p>Deep bore-well water from protected aquifers</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h4>Filtration</h4>
              <p>Multi-stage sand and carbon filtration</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h4>Purification</h4>
              <p>Advanced RO + UV treatment system</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h4>Mineralization</h4>
              <p>Essential minerals added for perfect taste</p>
            </div>
            <div className="process-step">
              <div className="step-number">05</div>
              <h4>Quality Check</h4>
              <p>Lab testing for purity and safety</p>
            </div>
            <div className="process-step">
              <div className="step-number">06</div>
              <h4>Bottling</h4>
              <p>Hygienic automated bottling process</p>
            </div>
          </div>
          
          <div className="text-center mt-4">
            <Link to="/manufacturing" className="btn btn-primary">
              Explore Our Facility
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Shikhar Dhara?</h2>
            <p>We're committed to delivering excellence in every bottle</p>
          </div>
          
          <div className="why-choose-grid">
            <div className="why-card">
              <div className="why-icon"><FaTint /></div>
              <h4>100% Pure</h4>
              <p>Multi-stage purification ensures crystal clear, safe drinking water every time.</p>
            </div>
            <div className="why-card">
              <div className="why-icon"><FaCheckCircle /></div>
              <h4>Certified Quality</h4>
              <p>BIS, FSSAI, and ISO certified products meeting all regulatory standards.</p>
            </div>
            <div className="why-card">
              <div className="why-icon"><FaIndustry /></div>
              <h4>Modern Factory</h4>
              <p>State-of-the-art manufacturing facility with automated production lines.</p>
            </div>
            <div className="why-card">
              <div className="why-icon"><FaMoneyBillWave /></div>
              <h4>Best Pricing</h4>
              <p>Direct manufacturer pricing with excellent margins for distributors.</p>
            </div>
            <div className="why-card">
              <div className="why-icon"><FaTruck /></div>
              <h4>Reliable Supply</h4>
              <p>Consistent supply chain ensuring products are always available.</p>
            </div>
            <div className="why-card">
              <div className="why-icon"><FaHandshake /></div>
              <h4>Partner Support</h4>
              <p>Dedicated support team for distributors and business partners.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="certifications-section section">
        <div className="container">
          <div className="section-header">
            <h2>Our Certifications</h2>
            <p>Quality you can trust, certified by leading authorities</p>
          </div>
          
          <div className="certifications-grid">
            <div className="cert-card">
              <img src="/logo & badge images/fssai-badge.png" alt="FSSAI Certified" />
              <h4>FSSAI Certified</h4>
              <p>Food Safety and Standards Authority of India approved</p>
            </div>
            <div className="cert-card">
              <img src="/Home Page images/bis-badge.png" alt="BIS Certified" />
              <h4>BIS Certified</h4>
              <p>Bureau of Indian Standards IS 14543 certified</p>
            </div>
            <div className="cert-card">
              <img src="/logo & badge images/iso-badge.png" alt="ISO Certified" />
              <h4>ISO Certified</h4>
              <p>International quality management standards</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Partner with Us?</h2>
            <p>Join our network of successful distributors across Uttar Pradesh and beyond</p>
            <div className="cta-buttons">
              <Link to="/distributor" className="btn btn-white">
                Become a Distributor
              </Link>
              <a 
                href="https://wa.me/918077894559?text=Hello, I'm interested in becoming a Shikhar Dhara distributor"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp"
              >
                <FaWhatsapp /> WhatsApp Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Preview */}
      <section className="contact-preview section bg-light">
        <div className="container">
          <div className="contact-preview-grid">
            <div className="contact-info-card">
              <div className="icon"><FaMapMarkerAlt /></div>
              <h4>Visit Us</h4>
              <p>UPSIDC Industrial Area, Building No. D-49, Parsakhera, Bareilly, UP - 243502</p>
            </div>
            <div className="contact-info-card">
              <div className="icon"><FaPhoneAlt /></div>
              <h4>Call Us</h4>
              <p>
                <a href="tel:+918077894559">+91 8077894559</a>
                <br />
                <a href="tel:+917983864997">+91 79838 64997</a>
              </p>
            </div>
            <div className="contact-info-card">
              <div className="icon"><FaEnvelope /></div>
              <h4>Email Us</h4>
              <p><a href="mailto:info@shikhardhara.com">info@shikhardhara.com</a></p>
            </div>
            <div className="contact-info-card">
              <div className="icon"><FaWhatsapp /></div>
              <h4>WhatsApp</h4>
              <p>
                <a 
                  href="https://wa.me/918077894559"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +91 8077894559
                </a>
                <br />
                <a 
                  href="https://wa.me/917983864997"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +91 79838 64997
                </a>
              </p>
            </div>
          </div>
          <div className="text-center mt-4">
            <Link to="/contact" className="btn btn-primary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
